import { render, staticRenderFns } from "./CompletedAllCaseClientList.vue?vue&type=template&id=4027e652&"
import script from "./CompletedAllCaseClientList.vue?vue&type=script&lang=js&"
export * from "./CompletedAllCaseClientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports